const LOCAL_STORAGE_PRODUCT_COMPARE_KEY = 'aquirify-product-compare';
const LOCAL_STORAGE_PRODUCT_COMPARE_DELIMITER = ',';
const PRODUCT_COMPARE_BUTTON_ACTIVE_CLASS = 'active';
const PRODUCT_COMPARE_GRID_LOADED_CLASS = 'loaded';

const product_compare_selectors = {
  button: '[button-product-compare]',
  grid: '[grid-product_compare]',
  productCard: '.product-card-product_compare',
};

document.addEventListener('DOMContentLoaded', () => {
  initProductCompareButtons();
  initProductCompareGrid();
});

document.addEventListener('aquirify-product-compare:updated', (event) => {
  //console.log('[Shopify Product Compare] Product Compare Updated ✅', event.detail.product_compare);
  initProductCompareGrid();
});

document.addEventListener('aquirify-product-compare:init-product-grid', (event) => {
  //console.log('[Shopify Product Compare] Product Compare Product List Loaded ✅', event.detail.product_compare);
});

document.addEventListener('aquirify-product-compare:init-buttons', (event) => {
  //console.log('[Shopify Product Compare] Product Compare Buttons Loaded ✅', event.detail.product_compare);
});

const fetchProductCompareCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=product-compare-card`;
  //alert(productTileTemplateUrl);
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    //alert(htmlDocument);
    const productCard = htmlDocument.documentElement.querySelector(product_compare_selectors.productCard);
    //alert(productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify product_compare] Failed to load content for handle: ${handle}`, err));
};

const setupProductCompareGrid = async (grid) => {
  const product_compare = getProductCompare();
  const requests = product_compare.map(fetchProductCompareCardHTML);
  const responses = await Promise.all(requests);
  const product_compareProductCards = responses.join('');
  grid.innerHTML = product_compareProductCards;
  grid.classList.add(PRODUCT_COMPARE_GRID_LOADED_CLASS);
  initProductCompareButtons();

  const event = new CustomEvent('aquirify-product-compare:init-product-grid', {
    detail: { product_compare: product_compare }
  });
  document.dispatchEvent(event);
};

const setupProductCompareButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify product_compare] Missing `data-product-handle` attribute. Failed to update the product_compare.');
    if (productcompareContains(productHandle)) button.classList.add(PRODUCT_COMPARE_BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateProductCompare(productHandle);
      button.classList.toggle(PRODUCT_COMPARE_BUTTON_ACTIVE_CLASS);
    });
  });
};

const initProductCompareGrid = () => {
  const grid = document.querySelector(product_compare_selectors.grid) || false;
  if (grid) setupProductCompareGrid(grid);
};

const initProductCompareButtons = () => {
  const buttons = document.querySelectorAll(product_compare_selectors.button) || [];
  if (buttons.length) setupProductCompareButtons(buttons);
  else return;
  const event = new CustomEvent('aquirify-product-compare:init-buttons', {
    detail: { product_compare: getProductCompare() }
  });
  document.dispatchEvent(event);
};

const getProductCompare = () => {
  const product_compare = localStorage.getItem(LOCAL_STORAGE_PRODUCT_COMPARE_KEY) || false;
  if (product_compare) return product_compare.split(LOCAL_STORAGE_PRODUCT_COMPARE_DELIMITER);
  return [];
};

const setProductCompare = (array) => {
  const product_compare = array.join(LOCAL_STORAGE_PRODUCT_COMPARE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_PRODUCT_COMPARE_KEY, product_compare);
  else localStorage.removeItem(LOCAL_STORAGE_PRODUCT_COMPARE_KEY);

  const event = new CustomEvent('aquirify-product-compare:updated', {
    detail: { product_compare: array }
  });
  document.dispatchEvent(event);

  return product_compare;
};

const updateProductCompare = (handle) => {
  const product_compare = getProductCompare();
  const indexInproduct_compare = product_compare.indexOf(handle);
  if (indexInproduct_compare === -1) product_compare.push(handle);
  else product_compare.splice(indexInproduct_compare, 1);
  return setProductCompare(product_compare);
};

const productcompareContains = (handle) => {
  const product_compare = getProductCompare();
  return product_compare.includes(handle);
};

const resetProductCompare = () => {
  return setProductCompare([]);
};
